import { Card, CardText, CardTitle } from 'reactstrap';


export default function Atome(){
  return(
    <Card body>
      <CardTitle>Atome</CardTitle>
      <CardText>
        Atome adalah aplikasi pembayaran yang memberi kemudahan untuk berbelanja dengan cicilan tanpa perlu menggunakan kartu kredit. <br/>
        Atome menyediakan 3 bulan cicilan sebagai pilihan pembayaran. Anda bisa menggunakan Atome untuk belanja di merchant online maupun offline yang sudah bekerjasama dengan Atome. <br/>
        Untuk info lebih lanjut bisa dilihat di <a href="https://shop.atome.id/nkp/text-info?type=FAQ" target="_blank">Atome's FAQ</a>
      </CardText>
    </Card>
  )
}